import { addOrUpdateMessage } from './addOrUpdateMessage';
import { IMessage } from 'src/interfaces/message';
import { getDocumentId } from 'src/utils/mongo/getDocumentId';
import { messageBelongsToConversation } from './messageBelongsToConversation';

/**
 * Interface for the conversation state
 */
interface ConversationState {
    conversations: Array<{
        _id: string;
        messages?: IMessage[];
    }>;
    conversation: {
        _id?: string;
        messages?: IMessage[];
    };
    messages: IMessage[];
}

/**
 * Interface for the MESSAGE_SOCKET action
 */
interface MessageSocketAction {
    payload: IMessage;
    conversation: string;
}

const sameId = (
    left: string | undefined | null,
    right: string | undefined | null
) => {
    if (left == null || right == null) return false;
    return String(left) === String(right);
};

/**
 * Handles the update of the state when a message is received by socket.
 * Updates the messages in:
 * 1. The matching conversation within state.conversations
 * 2. state.conversation.messages and state.messages — only when the message
 *    belongs to the currently open conversation
 */
export const handleMessageSocketUpdate = (
    state: ConversationState,
    action: MessageSocketAction
): ConversationState => {
    const { payload: newMessage, conversation: conversationId } = action;
    const targetConversationId = getDocumentId(conversationId);
    const openConversationId = getDocumentId(state.conversation);
    const isOpenConversation =
        sameId(targetConversationId, openConversationId) ||
        messageBelongsToConversation(newMessage, openConversationId);

    const updatedConversations = state.conversations.map((conv) => {
        if (sameId(getDocumentId(conv), targetConversationId)) {
            return {
                ...conv,
                messages: addOrUpdateMessage(conv.messages, newMessage),
            };
        }
        return conv;
    });

    if (!isOpenConversation) {
        return {
            ...state,
            conversations: updatedConversations,
        };
    }

    return {
        ...state,
        conversations: updatedConversations,
        conversation: {
            ...state.conversation,
            messages: addOrUpdateMessage(
                state.conversation.messages,
                newMessage
            ),
        },
        messages: addOrUpdateMessage(state.messages, newMessage),
    };
};
